import { render, staticRenderFns } from "./checkMechanism.vue?vue&type=template&id=63c62858&"
import script from "./checkMechanism.vue?vue&type=script&lang=js&"
export * from "./checkMechanism.vue?vue&type=script&lang=js&"
import style0 from "./checkMechanism.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports